import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { UserSettings } from './usersettings';

@Component({
    selector: 'acc-template',
    template: require('./accountTemplate.html'),
    styles: [``]
})
export class AccountTemplateComponent implements OnInit {

    @Input('accountList') accountList: any;
    @Input("cValue") cValue: any;
    @Input("dValue") dvalue: any;
    @Output() SelectedAccount = new EventEmitter();
    static parameters = [UtilityService]
    constructor(public utilityService: UtilityService) { }
    gridApiAcc: any;
    gridColumnApiAcc: any;
    paginationConf: any;
    glList: any;
    glDef1: any;
    selectedAccountInfo: any;
    defaultColDef: any;
    d: any;

    rowSelectionSingle: string;
    searchValue: any;
    ngOnInit(): void {
        //   console.log('account template init!');
        this.rowSelectionSingle = "single";
        this.d = this.dvalue;
        this.paginationConf = true;
    }
    ngAfterViewInit() {
        this.paginationConf = UserSettings.enablePagination;
    }
    onGridReadyAcc(params) {
        this.glDef1 = [
            { headerName: 'GL Code', field: 'GL_Code', width: 110 },
            { headerName: 'GL Desc', field: 'GL_Desc', width: 260 }

        ];

        this.glList = this.accountList.data;
        //   console.log('accountList', this.glList);
        //   console.log("param on ready:", params);
        this.gridApiAcc = params.api;
        this.gridColumnApiAcc = params.columnApi;

        setTimeout(() => {
            this.gridApiAcc.sizeColumnsToFit();

            //   console.log(this.selectedAccountInfo);
        }, 1);
        //   this.gridColumnApiCust.autoSizeColumns(allColumnIds);

        this.defaultColDef = {
            resizable: true,
        };



    }
    gridEventDown(event) {
        if (event.keyCode == 13) {
            //   console.log("keydown", event);
            this.accSelectionMain(this);
        } else if (event.keyCode == 8) {
            setTimeout(() => {
                $('#filter-text-box').focus().select();
            }, 200);
        } else if (event.keyCode >= 65 && event.keyCode <= 90) {
            $('#filter-text-box').focus().select();
        }
    }
    private accSelectionMain(self: this) {
        let selectedRows = self.gridApiAcc.getSelectedRows();
        let cust = selectedRows[0];
        //   console.log("selected Acc:", selectedRows[0]);

        if (cust != undefined) {
            //   console.log('selected account:', cust);
            this.SelectedAccount.emit(cust);
        }

    }

    invoiceInfo: any;
    accSelected(event) {
        let selectedRowCust = this.gridApiAcc.getSelectedRows();
        //   console.log("selectedRows", selectedRowCust[0]);
        this.selectedAccountInfo = selectedRowCust[0];
        // this.todayD = moment(this.salesorder.Return_Invoice_Date).format(this.dateFormat.dateInputFormat);
        //   console.log(this.selectedAccountInfo.GL_Desc);
    }
    onAccSelectionChanged(event) {
        this.accSelectionMain(this);
    }
    quickSearch(event, id) {
        //   console.log(id);
        if (id == 'product') {
            // this.gridApiPrd.setQuickFilter(this.searchValue);
            // this.gridApiPrd.onFilterChanged();
            // this.gridApiPrd.getModel().getRow(0).setSelected(true);
            // this.productFilterd = this.gridApiPrd.getModel().getRowCount().toLocaleString();
            // if (event.which == 13 || event.which == 40) {
            //     this.gridApiPrd.setFocusedCell(0, "Product_Code");
            // }
        }
        else if (id == 'account') {
            //   console.log('jk');
            this.gridApiAcc.setQuickFilter(this.searchValue);
            this.gridApiAcc.onFilterChanged();
            this.gridApiAcc.getModel().getRow(0).setSelected(true);
            // this.productFilterd = this.gridApiPrd.getModel().getRowCount().toLocaleString();
            if (event.which == 13 || event.which == 40) {
                this.gridApiAcc.setFocusedCell(0, "GL_Code");
            }
        }
    }
}
